import {css} from '@logistics-frontend/blocks/theme/css'
import {breakpoints, spacing} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  root: css`
    ${breakpoints.down('sm')} {
      position: absolute;
      inset: 0;
      border-radius: 0;
    }
  `,
  body: css`
    inline-size: ${spacing(82.5)}; // 660px
    min-block-size: ${spacing(50)}; // 400px

    ${breakpoints.down('sm')} {
      inline-size: 100%;
      min-block-size: auto;
    }
  `,
  iframe: css`
    border: none;
    inline-size: 100%;
    min-block-size: ${spacing(50)}; // 400px

    ${breakpoints.down('sm')} {
      min-block-size: 100%;
    }
  `,
}
